import Grid from "@mui/material/Grid";
import { Box, Stack, Typography } from "@mui/material";
import { LabelTemplate } from "./styles/table";
import { Employee } from "../types/processTypes";

import { BasicPostAppliedSingleValue } from "./components/basic/BasicPostApplied";
import { BasicDetail } from "./components/basic/BasicDetail";
import {
  BasicLanguage,
  BasicLanguageUltra,
} from "./components/basic/BasicLanguage";
import { BasicExperience } from "./components/basic/BasicExperience";
import {
  BasicSkillsOneLineHorz,
  BasicSkillsSmallHorz,
} from "./components/basic/BasicSkills";
import { BasicPassport } from "./components/basic/BasicPassport";
import { BasicFullName } from "./components/basic/BasicFullName";
import { BasicFace } from "./components/basic/BasicFace";
import { BasicStand } from "./components/basic/BasicStand";
import {
  BasicRemarks,
  BasicRemarksUltra,
  BasicRemarksVer,
} from "./components/basic/BasicRemarks";
import { BasicTitleSingleLang } from "./components/basic/BasicTitle";
import { BasicReference } from "./components/basic/BasicReference";
import { BasicPassportScan } from "./components/basic/BasicPassportScan";
import {
  BasicHeader,
  BasicHeaderNoBorder,
} from "./components/basic/BasicHeader";
import { Company } from "../../setups/types/setupTypes";

interface Props {
  selectedCompany: Company;
  currentEmployee: Employee;
  backgroundColor: string;
  cvTemplate: LabelTemplate;
}
function BasicTemplateTwo({
  selectedCompany,
  currentEmployee,
  backgroundColor,
  cvTemplate,
}: Props) {
  //a08745;f2f1f0 fffcf2
  return (
    <>
      <Box id="personalData" sx={{ p: 1 }}>
        <Grid
          container
          spacing={cvTemplate.spacing}
          sx={{
            p: 1,
            backgroundColor: backgroundColor,
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              height: "90%",
              // mb: 1,
            }}
          >
            {cvTemplate && currentEmployee && (
              <BasicHeaderNoBorder
                selectedCompany={selectedCompany}
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Grid>
          <Grid
            container
            item
            xs={12}
            spacing={cvTemplate.spacing}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12}>
              <BasicTitleSingleLang template={cvTemplate} />
            </Grid>
            <Grid container item xs={9}>
              <Stack spacing={cvTemplate.spacing} sx={{ width: "100%" }}>
                {/* <BasicReference
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                /> */}
                {cvTemplate && currentEmployee && (
                  <BasicPostAppliedSingleValue
                    currentEmployee={currentEmployee}
                    template={{
                      ...cvTemplate,
                      showCellBorders: true,
                      cellBorderBottomOnly: true,
                    }}
                    showHeader={false}
                    showAgent={true}
                    showName={false}
                    showReferenceNumber={false}
                    showProfession={true}
                    showSalary={true}
                    showContractPeriod={true}
                  />
                )}
              </Stack>
            </Grid>
            {/* Short Photo */}
            <Grid item xs={3}>
              {cvTemplate && currentEmployee && (
                <BasicFace
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                />
              )}
            </Grid>
          </Grid>

          <Grid item md={6} xs={12}>
            {cvTemplate && currentEmployee && (
              <BasicPassport
                currentEmployee={currentEmployee}
                template={{
                  ...cvTemplate,
                  showCellBorders: true,
                  cellBorderBottomOnly: true,
                }}
                showHeader={true}
                showPassportNumber={true}
                showIssueDate={true}
                showPlaceOfIssue={true}
                showExpiryDate={true}
              />
            )}
            {cvTemplate && currentEmployee && (
              <BasicDetail
                currentEmployee={currentEmployee}
                template={{
                  ...cvTemplate,
                  showCellBorders: true,
                  cellBorderBottomOnly: true,
                }}
                showHeader={true}
                showName={false}
                showNationality={false}
                showReligion={true}
                showDateOfBirth={true}
                showAge={true}
                showPlaceOfBirth={true}
                showMaritalStatus={true}
                showNumberOfChildren={true}
                showWeightHeight={true}
                showComplexion={true}
                showEducation={false}
                showLivingTown={false}
                showEmployeeTelephone={false}
                showContactName={false}
                showContactTelephone={false}
              />
            )}
            {cvTemplate && currentEmployee && (
              <BasicExperience
                currentEmployee={currentEmployee}
                template={{
                  ...cvTemplate,
                  showCellBorders: true,
                  cellBorderBottomOnly: true,
                }}
                type="basic"
              />
            )}
            {cvTemplate && currentEmployee && (
              <BasicSkillsOneLineHorz
                currentEmployee={currentEmployee}
                template={{
                  ...cvTemplate,
                  showCellBorders: true,
                  cellBorderBottomOnly: true,
                }}
              />
            )}
            {cvTemplate && currentEmployee && (
              <BasicRemarksUltra
                currentEmployee={currentEmployee}
                template={{
                  ...cvTemplate,
                  showCellBorders: true,
                  cellBorderBottomOnly: true,
                }}
              />
            )}
          </Grid>
          <Grid item md={6} xs={12}>
            <Stack
              spacing={cvTemplate.spacing}
              sx={{
                alignItems: "center",
              }}
            >
              {cvTemplate && currentEmployee && (
                <BasicDetail
                  currentEmployee={currentEmployee}
                  template={{
                    ...cvTemplate,
                    showCellBorders: true,
                    cellBorderBottomOnly: true,
                  }}
                  showHeader={true}
                  showName={true}
                  showNationality={true}
                  showReligion={false}
                  showDateOfBirth={false}
                  showAge={false}
                  showPlaceOfBirth={false}
                  showMaritalStatus={false}
                  showNumberOfChildren={false}
                  showWeightHeight={false}
                  showComplexion={false}
                  showEducation={false}
                  showLivingTown={false}
                  showEmployeeTelephone={false}
                  showContactName={false}
                  showContactTelephone={false}
                />
              )}
              {cvTemplate && currentEmployee && (
                <BasicLanguageUltra
                  currentEmployee={currentEmployee}
                  template={{
                    ...cvTemplate,
                    showCellBorders: true,
                    cellBorderBottomOnly: true,
                  }}
                  showEducation={false}
                />
              )}
              <Stack direction="row" spacing={1}>
                {cvTemplate && currentEmployee && (
                  <BasicStand
                    currentEmployee={currentEmployee}
                    template={cvTemplate}
                  />
                )}
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Box>
      {cvTemplate.numberOfPages === 2 && (
        <Stack
          id="passportData"
          sx={{
            p: 1,
            pt: 1,
            backgroundColor: backgroundColor,
            minHeight: "1500px",
          }}
        >
          {cvTemplate.addPassportHeader && (
            <Box
              sx={{
                height: "90%",
              }}
            >
              {cvTemplate && currentEmployee && (
                <BasicHeader
                  selectedCompany={selectedCompany}
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                />
              )}
            </Box>
          )}
          {cvTemplate && currentEmployee && (
            <Box
              sx={{
                mt: 15,
              }}
            >
              <BasicPassportScan
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            </Box>
          )}
        </Stack>
      )}
    </>
  );
}

export default BasicTemplateTwo;
